import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { map, Observable, tap } from 'rxjs';
import { Router } from '@angular/router';
import { HttpResponse } from '@angular/common/http';
import { response } from 'express';
import { UserCred, authStatus } from '../store/model/auth.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private apiService : ApiService,private router: Router) { }

  public loginAsync(userCred: UserCred): Observable<authStatus> {
    return this.apiService.post<authStatus>(`auth/login`, userCred).pipe(
      tap(response => {
       // localStorage.setItem('authStatus', 'true');
        //this.router.navigate(['/dashboard']);
      })
    );
  }

  public checkAuthStatus(): Observable<HttpResponse<any>> {
    return this.apiService.get<HttpResponse<any>>('auth/status')
  }


  // a modifier 
  public logoutAsync(): Observable<void> {
    return this.apiService.post<void>(`Auth/logout`, {}).pipe(
      tap(() => {
       // this.authStatus = false;
        localStorage.removeItem('authStatus');
        this.router.navigate(['/login']);
      })
    );
  }

}
